import api from '@/rest-api'

/**
 * Promoted partners/teams (promoSorting > 0) in their promoted order.
 *
 * The list endpoints return promoted entries first, so instead of downloading every record
 * (partner/all was 3.7 MB) pages are read until the first non-promoted entry appears.
 */
export async function fetchPromoted(path, filter = {}, perPage = 12) {
    const promoted = []
    const separator = path.includes('?') ? '&' : '?'
    for (let page = 1; page <= 20; page++) {
        const response = await api.post(`${path}${separator}page=${page}&per_page=${perPage}`, filter)
        const rows = (response && response.data) || []
        const promotedRows = rows.filter(row => row.promoSorting !== null && row.promoSorting !== undefined)
        promoted.push(...promotedRows)
        if (promotedRows.length < rows.length || page >= response.last_page) {
            break
        }
    }
    return promoted
        .filter(row => row.promoSorting > 0)
        .sort((a, b) => a.promoSorting - b.promoSorting)
}

export default {
    // partner/filtered lists promoted partners first
    partners() {
        return fetchPromoted('/partner/filtered', { available: true, approved: true })
    },
    // team/filtered sorted by promoSorting descending puts the promoted teams first
    teams() {
        return fetchPromoted('/team/filtered?available=true&sortOption=promoSorting&order=DESC')
    }
}
